export const origin = () => ({ x: 0, y: 0, z: 0 });
export const fromFine = (pos) => ({ x: pos.x(), y: pos.y(), z: pos.z() });
